import React, { useState, useMemo, useEffect } from "react";
import { FaHome, FaSearch, FaExternalLinkAlt, FaRobot, FaArrowUp } from "react-icons/fa";

const commands = [
    // Eğlence Komutları (9)
    { command: "m!hackle", description: "Belirtilen kullanıcıyı hackler.", usage: "m!hackle @kullanıcı", category: "Eğlence" },
    { command: "m!kaçcm", description: "Askerin uzunluğunu tahmin eder.", usage: "m!kaçcm", category: "Eğlence" },
    { command: "m!yazıtura", description: "Yazı tura atarsın.", usage: "m!yazıtura", category: "Eğlence" },
    { command: "m!sigara", description: "Sigara içersin.", usage: "m!sigara", category: "Eğlence" },
    { command: "m!maçyap", description: "Etiketlediğin kişiyle maç yaparsın.", usage: "m!maçyap @kullanıcı", category: "Eğlence" },
    { command: "m!başarım", description: "Yazdığınız mesajla Minecraft başarımı atar.", usage: "m!başarım [başarım]", category: "Eğlence" },
    { command: "m!sayıtahmin", description: "Sayı tahmin oyunu oynarsın.", usage: "m!sayıtahmin [sayı]", category: "Eğlence" },
    { command: "m!ship", description: "İki kişiyi shiplersin.", usage: "m!ship @kişi1 @kişi2", category: "Eğlence" },
    { command: "m!fakemesaj", description: "Etiketlediğin kişiye sahte mesaj yazdırırsın.", usage: "m!fakemesaj @kullanıcı [mesaj]", category: "Eğlence" },
    
    // Moderasyon Komutları (9)
    { command: "m!sil", description: "Belirttiğin kadar mesaj silersin.", usage: "m!sil [sayı]", category: "Moderasyon" },
    { command: "m!yavaşmod", description: "Kanala yavaş mod eklersin.", usage: "m!yavaşmod [saniye]", category: "Moderasyon" },
    { command: "m!oylama", description: "Belirttiğin içerikle oylama yaparsın.", usage: "m!oylama [soru]", category: "Moderasyon" },
    { command: "m!emojiekle", description: "Sunucuna emoji eklersin.", usage: "m!emojiekle [URL]", category: "Moderasyon" },
    { command: "m!kanal", description: "Kanalı kilitlersin veya açarsın.", usage: "m!kanal [aç/kapat]", category: "Moderasyon" },
    { command: "m!ban", description: "Belirttiğin kişiyi yasaklarsın.", usage: "m!ban @kullanıcı [sebep]", category: "Moderasyon" },
    { command: "m!unban", description: "ID'sini girdiğin kişinin yasağını kaldırırsın.", usage: "m!unban [ID]", category: "Moderasyon" },
    { command: "m!nuke", description: "Kanaldaki tüm mesajları silersin.", usage: "m!nuke", category: "Moderasyon" },
    { command: "m!isimdeğiştir", description: "Etiketlediğin kişinin adını değiştirirsin.", usage: "m!isimdeğiştir @kullanıcı [yeni isim]", category: "Moderasyon" },
    
    // Ekonomi Komutları (11)
    { command: "m!cüzdan", description: "Parana bakarsın.", usage: "m!cüzdan", category: "Ekonomi" },
    { command: "m!çalış", description: "Bir iş bulup çalışırsın.", usage: "m!çalış", category: "Ekonomi" },
    { command: "m!maaş", description: "Her 72 saatte bir maaş alırsın.", usage: "m!maaş", category: "Ekonomi" },
    { command: "m!balıktut", description: "Balık tutup para kazanırsın.", usage: "m!balıktut", category: "Ekonomi" },
    { command: "m!günlük", description: "Günlük paranı alırsın.", usage: "m!günlük", category: "Ekonomi" },
    { command: "m!dilen", description: "Dilenerek para kazanırsın.", usage: "m!dilen", category: "Ekonomi" },
    { command: "m!slot", description: "Bahis oynarsın.", usage: "m!slot [miktar]", category: "Ekonomi" },
    { command: "m!transfer", description: "Birine belirttiğin miktarda para gönderirsin.", usage: "m!transfer @kullanıcı [miktar]", category: "Ekonomi" },
    { command: "m!yatır", description: "Bankaya para yatırırsın.", usage: "m!yatır [miktar]", category: "Ekonomi" },
    { command: "m!çek", description: "Bankadan para çekersin.", usage: "m!çek [miktar]", category: "Ekonomi" },
    { command: "m!cf", description: "Coinflip oynarsın.", usage: "m!cf [miktar]", category: "Ekonomi" },
    
    // Kullanıcı Komutları (8)
    { command: "m!avatar", description: "Avatarına bakarsın.", usage: "m!avatar @kullanıcı", category: "Kullanıcı" },
    { command: "m!kullanıcıbilgi", description: "Kullanıcı bilgilerine bakarsın.", usage: "m!kullanıcıbilgi @kullanıcı", category: "Kullanıcı" },
    { command: "m!afk", description: "AFK moduna geçersin.", usage: "m!afk [mesaj]", category: "Kullanıcı" },
    { command: "m!banner", description: "Bannerini görüntülersin.", usage: "m!banner", category: "Kullanıcı" },
    { command: "m!notal", description: "Not alırsın.", usage: "m!notal [not]", category: "Kullanıcı" },
    { command: "m!notum", description: "Notunu görüntülersin.", usage: "m!notum", category: "Kullanıcı" },
    { command: "m!notsıfırla", description: "Mevcut notunu sıfırlarsın.", usage: "m!notsıfırla", category: "Kullanıcı" },
    { command: "m!emojiler", description: "Sunucudaki emojileri gösterir.", usage: "m!emojiler", category: "Kullanıcı" },
    
    // Bot Komutları (6)
    { command: "m!istatistik", description: "Botun istatistiklerine bakarsın.", usage: "m!istatistik", category: "Bot" },
    { command: "m!lb", description: "Lider tablosuna bakarsın.", usage: "m!lb", category: "Bot" },
    { command: "m!sunucubilgi", description: "Sunucunun bilgilerine bakarsın.", usage: "m!sunucubilgi", category: "Bot" },
    { command: "m!hesapla", description: "Hesaplama yaparsın.", usage: "m!hesapla [işlem]", category: "Bot" },
    
    // Ayarlanabilir Komutlar (1)
    { command: "m!saas", description: "Otomatik Sa-As sistemini açar/kapatır.", usage: "m!saas [aç/kapat]", category: "Ayarlanabilir" }
];

const Komutlar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Hepsi");
  const [selectedCommand, setSelectedCommand] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const categories = ["Hepsi", "Eğlence", "Moderasyon", "Ekonomi", "Kullanıcı", "Bot", "Ayarlanabilir"];

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [menuOpen]);

  const filteredCommands = useMemo(() => {
    return commands.filter(cmd => {
      const matchesSearch = cmd.command.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          cmd.description.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory === "Hepsi" || cmd.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchTerm, selectedCategory]);

  return (
    <div className="modern-body">
      <header className="glass-header">
        <div className="title">
          <img src="https://r.resimlink.com/6gMxa9P.png" alt="Midas" className="logo" />
          <h1>Midas</h1>
        </div>
        
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <div className={menuOpen ? "bar open" : "bar"}></div>
          <div className={menuOpen ? "bar open" : "bar"}></div>
          <div className={menuOpen ? "bar open" : "bar"}></div>
        </div>

        <nav className={menuOpen ? "nav-menu active" : "nav-menu"}>
          <a href="/"><FaHome /> Ana Sayfa</a>
          <a href="https://discord.gg/PfAdzWsjVN" target="_blank" rel="noreferrer">
            <FaExternalLinkAlt /> Destek Sunucusu
          </a>
        </nav>
      </header>

      <main className="container">
        <section className="hero">
          <FaRobot className="hero-icon" />
          <h2>Midas Komut Paneli</h2>
        </section>

        {/* Kategori Filtreleme Bölümü */}
        <div className="category-filter">
          {categories.map(cat => (
            <button 
              key={cat}
              className={selectedCategory === cat ? "cat-btn active" : "cat-btn"}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat} <span>({cat === "Hepsi" ? commands.length : commands.filter(c => c.category === cat).length})</span>
            </button>
          ))}
        </div>

        <div className="search-wrapper">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Komut ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="cmds-grid">
          {filteredCommands.length > 0 ? (
            filteredCommands.map((cmd, index) => (
              <div key={index} className="cmd-card">
                <span className="category-badge">{cmd.category}</span>
                <div className="cmd-header">
                  <span className="prefix">m!</span>
                  <h3>{cmd.command.replace("m!", "")}</h3>
                </div>
                <p>{cmd.description}</p>
                
                <button 
                  className={`example-btn ${selectedCommand === cmd.command ? 'active' : ''}`}
                  onClick={() => setSelectedCommand(selectedCommand === cmd.command ? null : cmd.command)}
                >
                  {selectedCommand === cmd.command ? "Gizle" : "Örnek Kullanım"}
                </button>

                {selectedCommand === cmd.command && (
                  <div className="usage-popup">
                    <code>{cmd.usage}</code>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="no-result">
              <p>Sonuç bulunamadı...</p>
            </div>
          )}
        </div>
      </main>

      <div 
        className={`scroll-to-top ${isVisible ? 'visible' : ''}`} 
        onClick={scrollToTop}
      >
        <FaArrowUp />
      </div>

      <footer className="simple-footer">
        <p>© 2026 Midas Discord Bot - Tüm Hakları Saklıdır.</p>
      </footer>
    </div>
  );
};

export default Komutlar;
